module.exports = __webpack_public_path__ + "static/1 (1)-f37cc94d8b03e92c4bd228c702405656.png";